"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PropsWithChildren, useEffect } from "react";
import { QUERY_CONFIG } from "@shared/src/queryClient";

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: QueryClient;
  }
}
export const queryClient = new QueryClient(QUERY_CONFIG);

export function QueryProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    window.__TANSTACK_QUERY_CLIENT__ = queryClient;
  }, []);
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}


